// Joya Headquarter — shift planning, staffing rules, labor cost, payroll checks (Hebrew).
// Same keys in staffing.en.js.
export default {
  // ---- staffing plans
  'joya.staff.sub': 'הצעת איוש שבועית לפי הביקוש הצפוי בכל משמרת. אפשר לשאול, לערוך ולאשר.',
  'joya.staff.tabPlans': 'תוכניות',
  'joya.staff.tabForecast': 'תחזית ביקוש',
  'joya.staff.proposeTitle': 'הצעה לשבוע',
  'joya.staff.proposeHelp': 'המערכת מנתחת את הפעילות בקופה בשבועות הקודמים, צופה ביקוש לכל משמרת ומחשבת כמה עובדים צריך לפי הכללים.',
  'joya.staff.proposeFor': 'ההצעה תיבנה עבור:',
  'joya.staff.week': 'שבוע',
  'joya.staff.weekHint': 'אפשר לבחור כל יום בשבוע — השבוע מתחיל ביום ראשון.',
  'joya.staff.propose': 'הכנת הצעה',
  'joya.staff.proposeAgain': 'הצעה חדשה מאפס',
  'joya.staff.noPlans': 'אין עדיין תוכניות איוש.',
  'joya.staff.weekOf': 'שבוע',
  'joya.staff.peopleShifts': 'משבצות עובדים בשבוע',
  'joya.staff.proposedBy': 'הוצע על ידי',
  'joya.staff.approvedBy': 'אושר על ידי',
  'joya.staff.unitsHelpTitle': 'מה פירוש יחידות הביקוש?',
  'joya.staff.forecastHelp': 'התחזית היא החציון של אותו יום בשבוע בשבועות הקודמים. ימים בלי נתונים לא נספרים — הם לא נחשבים כאפס.',
  'joya.staff.forecastMethod': 'חציון של אותו יום ב-{weeks} השבועות הקודמים; פחות מ-{min} ימים עם נתונים = ביטחון נמוך',
  'joya.staff.noShifts': 'לסניף הזה עדיין לא הוגדרו משמרות (כללי איוש ← משמרות).',
  'joya.staff.nDays_one': 'לפי יום אחד',
  'joya.staff.nDays_other': 'לפי {count} ימים',
  'joya.staff.pastDates': 'התאריכים שנבדקו',
  'joya.staff.histLine': '{checks} חשבונות · סועדים:',
  'joya.staff.missingNotZero': 'תאריך בלי מכירות (המסעדה סגורה) לא נכנס ללמידה.',

  // ---- one plan
  'joya.staff.tabWeek': 'השבוע',
  'joya.staff.tabActual': 'מתוכנן מול בפועל',
  'joya.staff.tabProposal': 'ההצעה המקורית',
  'joya.staff.tabLog': 'יומן שינויים',
  'joya.staff.proposedByAt': 'הוצע: {who} · {when}',
  'joya.staff.approvedByAt': 'אושר: {who} · {when}',
  'joya.staff.rejectedByAt': 'נדחה: {who} · {when}',
  'joya.staff.reopen': 'פתיחה מחדש לעריכה',
  'joya.staff.warningsTitle': 'שימו לב:',
  'joya.staff.warn.CANNOT_COMPUTE': '{role}: אי אפשר לחשב — אין נתוני ביקוש ({units}) ואין מינימום. הוסיפו ידנית.',
  'joya.staff.warn.PEAK_DEMAND_UNKNOWN': '{role}: תוספת השיא לא חושבה — חסר נתון ({units}).',
  'joya.staff.warn.MIN_ABOVE_MAX': '{role}: המינימום ({min}) גבוה מהמקסימום ({max}) — בדקו את הכללים.',
  'joya.staff.warn.ZERO_BELOW_MANDATORY': '{role}: החישוב יצא 0, אבל יש מינימום חובה של {min}.',
  'joya.staff.violationsTitle': 'התוכנית מתחת למינימום חובה:',
  'joya.staff.minByAdmin': 'מינימום חובה נקבע על ידי הנהלת הרשת בכללי האיוש. עריכה של התוכנית לא יכולה לרדת ממנו.',
  'joya.staff.exportCsv': '⬇ קובץ להעברה ל-Tabit (CSV)',
  'joya.staff.exportNote': 'אין חיבור אוטומטי ל-Tabit — ייבאו או העתיקו את הקובץ ידנית.',
  'joya.staff.closedDay': 'אין משמרת ביום הזה.',
  'joya.staff.people_one': 'עובד אחד',
  'joya.staff.people_other': '{count} עובדים',
  'joya.staff.peak': 'שעת שיא',
  'joya.staff.added': 'נוסף ידנית',
  'joya.staff.min': 'מינימום {n}',
  'joya.staff.proposedWas': 'בהצעה המקורית: {n}',
  'joya.staff.learned': 'נלמד מהעריכות שלכם: {delta} ({seen} מתוך {window} השבועות האחרונים). תוצאת הכלל: {rule}',
  'joya.staff.baseline': 'האיוש הקודם (דוגמה): {n}',
  'joya.staff.addRole': 'הוספת תפקיד',
  'joya.staff.why': 'למה המספר הזה?',
  'joya.staff.demandUsed': 'ביקוש שנבדק',
  'joya.staff.forecastValue': 'ערך צפוי',
  'joya.staff.basedOn': 'מבוסס על',
  'joya.staff.confidence': 'רמת ביטחון',
  'joya.staff.note.DEMAND_UNKNOWN': 'אין נתון ביקוש ({unit}) — כלל הביקוש לא חושב.',
  'joya.staff.note.MIN_ONLY_DEMAND_UNKNOWN': 'הביקוש לא ידוע, לכן הוצע רק המינימום.',
  'joya.staff.note.FROM_BASELINE': 'אין כלל לתפקיד הזה — המספר לקוח מהאיוש הקודם.',
  'joya.staff.addedByManager': 'השורה נוספה ידנית — אין לה חישוב של המערכת.',
  'joya.staff.minExplain': 'מינימום חובה במשמרת הזו: {n}.',
  'joya.staff.headcount': 'מספר עובדים',
  'joya.staff.start': 'התחלה',
  'joya.staff.end': 'סיום',
  'joya.staff.role': 'תפקיד',
  'joya.staff.removeLine': 'הסרת השורה',
  'joya.staff.approveTitle': 'אישור התוכנית',
  'joya.staff.approveHelp': 'אחרי האישור התוכנית נשמרת כפי שהיא. ההצעה המקורית נשמרת לידה.',
  'joya.staff.rejectTitle': 'דחיית התוכנית',
  'joya.staff.ex1': 'למה צריך שלושה טבחים ביום חמישי בבוקר?',
  'joya.staff.ex2': 'הראו את הביקוש בימי חמישי האחרונים',
  'joya.staff.ex3': 'הוסיפו מלצר שמתחיל בצהריים ביום חמישי',
  'joya.staff.ex4': 'חשבו מחדש עם שני ראנרים מעל הסף שהגדרתי',
  'joya.staff.weekNotStarted': 'השבוע עוד לא התחיל — אין עדיין נתונים בפועל.',
  'joya.staff.hoursByRole': 'שעות לפי תפקיד',
  'joya.staff.roleUnknown': 'תפקיד לא ידוע',
  'joya.staff.rowsMissingHours_one': 'שורה אחת בלי שעות',
  'joya.staff.rowsMissingHours_other': '{count} שורות בלי שעות',
  'joya.staff.plannedArrowActual': 'מתוכנן → בפועל',
  'joya.staff.forecastArrowActual': 'בכל שורה: צפוי → בפועל',
  'joya.staff.noActualData': 'אין נתוני קופה ליום הזה',
  'joya.staff.plannedPeopleHours': 'מתוכנן: עובדים · שעות',
  'joya.staff.proposalHelp': 'ההצעה כפי שהמערכת הכינה אותה, לפני כל עריכה. היא לא משתנה.',
  'joya.staff.noEdits': 'אין עדיין שינויים.',
  'joya.staff.via': 'דרך',
  'joya.staff.via.UI': 'המסך',
  'joya.staff.via.CHAT': 'שיחה עם המטה',
  'joya.staff.beforeAfter': 'לפני / אחרי',
  'joya.staff.action.ADD': 'הוספה',
  'joya.staff.action.SET': 'שינוי',
  'joya.staff.action.REMOVE': 'הסרה',
  'joya.staff.action.APPROVE': 'אישור',
  'joya.staff.action.REJECT': 'דחייה',
  'joya.staff.action.REOPEN': 'פתיחה מחדש',

  // ---- rules
  'joya.rules.tabRules': 'כללים',
  'joya.rules.tabShifts': 'משמרות',
  'joya.rules.tabBaseline': 'איוש קודם',
  'joya.rules.tabRoles': 'תפקידים',
  'joya.rules.intro': 'הכלל הספציפי ביותר קובע: סניף + משמרת + ימים, לפני סניף, לפני כל הסניפים. כלל יחס וכלל מדרגות יחד — המספר הגדול מביניהם. עריכה של תוכנית שבועית לא משנה את הכללים. כללים לכל הרשת וכללי חובה — רק הנהלת הרשת.',
  'joya.rules.showingFirst': 'מוצג הסניף הראשון. בחרו סניף בראש העמוד.',
  'joya.rules.newRule': 'כלל חדש',
  'joya.rules.editRule': 'עריכת כלל',
  'joya.rules.none': 'אין עדיין כללים.',
  'joya.rules.s.FIXED': 'בדיוק {count}',
  'joya.rules.s.MIN': 'לפחות {count}',
  'joya.rules.s.MAX': 'לכל היותר {count}',
  'joya.rules.s.RATIO': '1 לכל {per} ({unit})',
  'joya.rules.s.STEPS': 'לפי מדרגות של {unit}: {steps}',
  'joya.rules.s.step': 'מעל {above} → {count}',
  'joya.rules.s.PEAK_EXTRA': 'עוד {count} מ-{start} עד {end} כשה{unit} מעל {above}',
  'joya.rules.allLocations': 'כל הסניפים',
  'joya.rules.allShifts': 'כל המשמרות',
  'joya.rules.allDays': 'כל הימים',
  'joya.rules.thisLocation': 'הסניף',
  'joya.rules.thisShift': 'המשמרת',
  'joya.rules.mandatory': 'חובה',
  'joya.rules.chainWide': 'כל הרשת',
  'joya.rules.locationRule': 'כלל של הסניף',
  'joya.rules.inactive': 'לא פעיל',
  'joya.rules.adminOnly': 'רק הנהלת הרשת יכולה לשנות',
  'joya.rules.confirmDelete': 'למחוק את הכלל?',
  'joya.rules.type': 'סוג הכלל',
  'joya.rules.type.FIXED': 'מספר קבוע',
  'joya.rules.type.MIN': 'מינימום',
  'joya.rules.type.MAX': 'מקסימום',
  'joya.rules.type.RATIO': 'יחס לביקוש',
  'joya.rules.type.STEPS': 'מדרגות ביקוש',
  'joya.rules.type.PEAK_EXTRA': 'תוספת בשעת שיא',
  'joya.rules.typeHelp.FIXED': 'תמיד אותו מספר, בלי קשר לביקוש (למשל צ׳קר אחד בבוקר).',
  'joya.rules.typeHelp.MIN': 'אף פעם לא פחות מזה. כלל חובה לא יכול לרדת בעריכה.',
  'joya.rules.typeHelp.MAX': 'אף פעם לא יותר מזה.',
  'joya.rules.typeHelp.RATIO': 'עובד אחד לכל כמות ביקוש, מעוגל למעלה (למשל מלצר לכל 30 סועדים).',
  'joya.rules.typeHelp.STEPS': 'מספר עובדים לפי טווחים: כשהביקוש מעל ערך מסוים — כך וכך עובדים.',
  'joya.rules.typeHelp.PEAK_EXTRA': 'עובדים נוספים לשעות מסוימות, רק כשהביקוש מעל סף.',
  'joya.rules.unit': 'יחידת ביקוש',
  'joya.rules.extraCount': 'כמה עובדים נוספים',
  'joya.rules.per': 'עובד אחד לכל',
  'joya.rules.perHint': 'למשל 30 = עובד לכל 30 סועדים. התוצאה מעוגלת למעלה.',
  'joya.rules.steps': 'מדרגות',
  'joya.rules.stepsHint': 'בכל שורה: "מעל" (ביקוש) ומספר עובדים. המדרגה הגבוהה שעברו אותה קובעת.',
  'joya.rules.above': 'מעל',
  'joya.rules.addStep': 'מדרגה',
  'joya.rules.scopeLocation': 'חל על סניף',
  'joya.rules.scopeShift': 'חל על משמרת',
  'joya.rules.scopeDays': 'חל על ימים',
  'joya.rules.daysHint': 'בלי בחירה = כל הימים.',
  'joya.rules.roleStart': 'התחלה לתפקיד (לא חובה)',
  'joya.rules.roleEnd': 'סיום לתפקיד (לא חובה)',
  'joya.rules.mandatoryLabel': 'כלל חובה — מנהל סניף לא יכול לרדת ממנו',
  'joya.rules.active': 'פעיל',
  'joya.rules.newShift': 'משמרת חדשה',
  'joya.rules.editShift': 'עריכת משמרת',
  'joya.rules.shiftCode': 'קוד',
  'joya.rules.codeHint': 'אותיות קטנות באנגלית, ספרות ו-_ (למשל morning).',
  'joya.rules.shiftName': 'שם',
  'joya.rules.shiftDays': 'ימים',
  'joya.rules.hours': 'שעות',
  'joya.rules.pastMidnight': 'שעת סיום לפני ההתחלה = אחרי חצות.',
  'joya.rules.baselineIntro': 'כמה עובדים היו בפועל לפני המערכת — דוגמה ובסיס. משמש להשוואה, ולתפקיד שאין לו כלל. השינוי נשמר כשיוצאים מהשדה.',
  'joya.rules.code': 'קוד',
  'joya.rules.newRole': 'תפקיד חדש',
  'joya.rules.nameHe': 'שם בעברית',
  'joya.rules.nameEn': 'שם באנגלית',
  'joya.rules.sort': 'סדר תצוגה',

  // ---- labor
  'joya.labor.sub': 'מכירות, שעות עבודה ועלות העבודה כפי שה-Admin של Allegro מחשב אותה.',
  'joya.labor.last7': '7 ימים אחרונים',
  'joya.labor.last30': '30 ימים אחרונים',
  'joya.labor.lastMonth': 'החודש הקודם',
  'joya.labor.howTitle': 'איך מחושב?',
  'joya.labor.howGross': 'שכר ברוטו הוא מה שהעובד מרוויח לפני ניכויים. עלות המעסיק כוללת גם את מה שהמעסיק משלם מעל הברוטו (פנסיה, ביטוח לאומי ועוד) — היא גבוהה יותר.',
  'joya.labor.howKnown': 'עלות העבודה מגיעה מה-Admin של Allegro ולפי כללי השכר שלו: שעות אחרי ניכוי הפסקות ב-100% / 125% / 150% × השכר של התפקיד, בתפקידי טיפ רק ההשלמה (בלי שורת שכר ובלי טיפ), ושכר גלובלי. "ברוטו בתלוש" = שכר + נסיעות + בונוס מהתלוש. חודש בלי שכר שמור נבנה ב-Admin מדוחות Tabit כמו שכר חדש (לא נשמר, ועוד יכול להשתנות). שעות בלי שכר ב-Admin לא מתומחרות — הן מופיעות ברשימה.',
  'joya.labor.noPayroll': 'שכר ועלות עבודה דורשים הרשאת שכר.',
  'joya.labor.sales': 'מכירות',
  'joya.labor.salesDaysMissing_one': 'יום אחד בלי מכירות בתקופה (סגור)',
  'joya.labor.salesDaysMissing_other': '{count} ימים בלי מכירות בתקופה (סגור)',
  'joya.labor.hours': 'שעות עבודה',
  'joya.labor.rowsMissingHours_one': 'שורת נוכחות אחת בלי שעת כניסה/יציאה — לא נספרה',
  'joya.labor.rowsMissingHours_other': '{count} שורות נוכחות בלי שעת כניסה/יציאה — לא נספרו',
  'joya.labor.salesPerHour': 'מכירות לשעת עבודה',
  'joya.labor.laborPct': 'עלות עבודה מהמכירות',
  'joya.labor.costTitle': 'עלות עבודה (כללי השכר)',
  'joya.labor.laborCost': 'עלות עבודה',
  'joya.labor.payslipGross': 'ברוטו בתלוש',
  'joya.labor.payslipPct': 'ברוטו בתלוש מהמכירות',
  'joya.labor.payroll.saved': '— שכר שמור',
  'joya.labor.payroll.tabit': '— מ-Tabit, עוד לא נשמר',
  'joya.labor.payroll.none': '— אין שכר',
  'joya.labor.hoursWithoutWage': 'ל-{hours} שעות אין שכר ב-Admin ({count} עובדים), לכן העלות נמוכה מהאמת:',
  'joya.labor.incomplete': 'ל-{pct}% מהשעות אין שכר — זו לא עלות העבודה האמיתית.',
  'joya.labor.notInEmployees': 'לא בטבלת העובדים',
  'joya.labor.knownBadge': 'Admin של Allegro',
  'joya.labor.noEmployerLines': 'ב-Allegro אין עלות מעסיק — ידוע רק שכר הברוטו.',
  'joya.labor.noKnown': 'אין עלות עבודה: ב-Admin של Allegro אין שכר ואין דוח Tabit לתקופה הזו.',
  'joya.labor.pvaTitle': 'שעות מתוכננות מול בפועל (תוכניות מאושרות)',
  'joya.labor.pvaNone': 'אין תוכניות איוש מאושרות בתקופה הזו.',

  // ---- payroll
  'joya.payroll.banner': 'הבדיקות האלה עוזרות להכין את השכר. האישור הסופי של השכר נעשה על ידי אדם במערכת השכר — שום דבר כאן לא מאשר ולא משלם.',
  'joya.payroll.month': 'חודש',
  'joya.payroll.tabIssues': 'בעיות לבדיקה',
  'joya.payroll.tabLines': 'שורות שכר',
  'joya.payroll.run': 'הרצת בדיקות',
  'joya.payroll.runFor': 'הבדיקה תרוץ עבור:',
  'joya.payroll.result': 'נבדקו {rows} שורות נוכחות · נמצאו {found} · חדשות {created} · נסגרו (כבר לא קיימות) {closed}.',
  'joya.payroll.notCompared': 'שעות השכר לא הושוו (אין הרשאת שכר).',
  'joya.payroll.noIssues': 'לא נמצאו בעיות לחודש הזה.',
  'joya.payroll.employee': 'עובד',
  'joya.payroll.rowCount': 'שורות',
  'joya.payroll.attendanceHours': 'שעות לפי נוכחות',
  'joya.payroll.payrollHours': 'שעות בשכר',
  'joya.payroll.difference': 'הפרש (שעות)',
  'joya.payroll.corrected': 'תוקן',
  'joya.payroll.mapId': 'מיפוי המזהה לעובד ←',
  'joya.payroll.kind.MISSING_CLOCK_OUT': 'חסרה שעת יציאה',
  'joya.payroll.kind.MISSING_CLOCK_IN': 'חסרה שעת כניסה',
  'joya.payroll.kind.DUPLICATE': 'שורה כפולה',
  'joya.payroll.kind.OVERLAP': 'שעות חופפות',
  'joya.payroll.kind.UNMATCHED_EMPLOYEE': 'מזהה עובד לא מוכר',
  'joya.payroll.kind.HOURS_MISMATCH': 'פער בין שעות שכר לנוכחות',
  'joya.payroll.kind.NO_ATTENDANCE': 'שכר בלי נוכחות',
  'joya.payroll.kind.LONG_SHIFT': 'משמרת ארוכה במיוחד',
  'joya.payroll.kindHelp.MISSING_CLOCK_OUT': 'העובד נכנס ולא נרשמה יציאה. השעות לא נספרות עד שמתקנים.',
  'joya.payroll.kindHelp.MISSING_CLOCK_IN': 'לא נרשמה כניסה. השעות לא נספרות עד שמתקנים.',
  'joya.payroll.kindHelp.DUPLICATE': 'אותה שורה מופיעה פעמיים. אחת מהן צריכה לצאת מהחישוב.',
  'joya.payroll.kindHelp.OVERLAP': 'לאותו עובד יש שתי שורות עם שעות חופפות.',
  'joya.payroll.kindHelp.UNMATCHED_EMPLOYEE': 'המזהה מהקובץ לא שייך לאף עובד. ההתאמה נעשית לפי מזהה, לא לפי שם.',
  'joya.payroll.kindHelp.HOURS_MISMATCH': 'סך השעות בשורות השכר שונה מסך השעות בנוכחות.',
  'joya.payroll.kindHelp.NO_ATTENDANCE': 'יש לעובד שורות שכר בחודש, אבל אין לו נוכחות.',
  'joya.payroll.kindHelp.LONG_SHIFT': 'משמרת ארוכה מ-{limit} שעות — אולי טעות ביציאה.',
  'joya.payroll.act.SET_TIMES': 'תיקון שעות',
  'joya.payroll.act.EXCLUDE': 'הוצאת השורה',
  'joya.payroll.act.ACCEPTED': 'תקין כמו שהוא',
  'joya.payroll.act.DISMISSED': 'לא בעיה',
  'joya.payroll.act.OPEN': 'פתיחה מחדש',
  'joya.payroll.clockIn': 'כניסה',
  'joya.payroll.clockOut': 'יציאה',
  'joya.payroll.excludeHelp': 'השורה לא תיספר בשעות. השורה המקורית נשארת שמורה.',
  'joya.payroll.noteRequired': 'הערה (חובה)',
  'joya.payroll.noteHint': 'מה נבדק ומי אישר. למשל: "אושר מול אחראי המשמרת".',
  'joya.payroll.rawKept': 'הנתון המקורי מהקובץ לא משתנה — התיקון נשמר בנפרד, עם השם שלכם והתאריך.',
  'joya.payroll.totals': 'סיכום החודש',
  'joya.payroll.other': 'אחר',
  'joya.payroll.linesNoAmount_one': 'שורה אחת בלי סכום',
  'joya.payroll.linesNoAmount_other': '{count} שורות בלי סכום',
  'joya.payroll.noLines': 'אין שורות שכר לחודש הזה.',
  'joya.payroll.costType.GROSS_WAGE': 'ברוטו',
  'joya.payroll.costType.EMPLOYER_COST': 'עלות מעסיק',
  'joya.payroll.costType.OTHER': 'אחר',
};
